import React, { useState, useEffect } from "react";
import "./Property.css";
import img6 from "../assets/step1.png";
import img7 from "../assets/step3.png";
import img8 from "../assets/step2.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import next from "../assets/icon2.svg";
import prev from "../assets/icon1.svg";

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div className="slick-arrow slick-next" onClick={onClick}>
      <img src={next} alt="Next" className="arrows" />
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="slick-arrow slick-prev" onClick={onClick}>
      <img src={prev} alt="Previous" className="arrows" />
    </div>
  );
}

export default function Property() {
  const cardData = [
    {
      id: 1,
      image: img6,
      title: "Login & Access Dashboard",
      description: "Sign in and manage everything from one smart dashboard.",
    },
    {
      id: 2,
      image: img8,
      title: "Choose Theme & Add Details",
      description:
        "Pick a custom or ready-made theme and add your business info.",
    },
    {
      id: 3,
      image: img7,
      title: "List Properties & Go Live",
      description:
        "Upload your properties and showcase them in a professional, ready-to-share app.",
    },
  ];

  const [slidesToShow, setSlidesToShow] = useState(2);
  const [centerMode, setCenterMode] = useState(true);
  const [centerPadding, setCenterPadding] = useState("30px");

  useEffect(() => {
    const updateSettings = () => {
      const width = window.innerWidth;

      if (width >= 850) {
        setSlidesToShow(2);
        setCenterMode(true);
        setCenterPadding("30px");
      } else if (width >= 576) {
        setSlidesToShow(2);
        setCenterMode(true);
        setCenterPadding("30px");
      } else if (width >= 450) {
        setSlidesToShow(1);
        setCenterMode(true);
        setCenterPadding("60px");
      } else {
        setSlidesToShow(1);
        setCenterMode(true);
        setCenterPadding("20px");
      }
    };

    updateSettings();
    window.addEventListener("resize", updateSettings);
    return () => window.removeEventListener("resize", updateSettings);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    centerMode,
    centerPadding,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="property wrapper">
      <h2>Your Property App—Live in 15 Minutes</h2>
      <p>
        List your property in minutes, reach verified buyers instantly, and
        start selling faster without middlemen.
      </p>

      <div className="cards">
        {cardData.map((card) => (
          <div className="card" key={card.id}>
            <img src={card.image} alt={card.title} />
            <div className="content">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mobilecards">
        <Slider {...settings}>
          {cardData.map((card) => (
            <div className="card" key={card.id}>
              <img src={card.image} alt={card.title} />
              <div className="content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
